import React, { Component } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import Button from '../Button/Button';
import { ReactComponent as CloseCrossIcon } from '../../../../../icons/dp-close-cross.svg';

import './dpit-popup-hint.scss';
import './dpit-popup-promo.scss';

export default class Popup extends Component {
	render() {
		const mainClasses = classNames({
			[this.props.classBEMRoot]: true,
			[this.props.className]: this.props.className,
			'dpit-pulse-once-2s': this.props.pulse,
			'dpit-pulse-infinite-2s': this.props.pulseInfinite,
			[`${this.props.classBEMRoot}--${this.props.type}`]: this.props.type,
			[`${this.props.classBEMRoot}--dismissible`]: this.props.dismissible,
		});
		return (

			<CSSTransition
				in={this.props.active && (!!this.props.title || !!this.props.desc)}
				timeout={300}
				classNames={`${this.props.classBEMRoot}__transition`}
				unmountOnExit
				key={this.props.keyId}
			>
				<div className={mainClasses}>
					<Button
						classBEMRoot={`${this.props.classBEMRoot}__close-button`}
						className={this.props.closeButtonClass}
						title={this.props.closeButtonTitle}
						active={this.props.dismissible}
						onClick={this.props.onCloseClick}
					>
						<CloseCrossIcon></CloseCrossIcon>
					</Button>
					<div className={`${this.props.classBEMRoot}__content`}>
						{this.props.imageSrc
							? <img
								className={`${this.props.classBEMRoot}__content__image`}
								src={this.props.imageSrc}
								alt={this.props.imageAlt}
							/>
							: null}
						<div className={`${this.props.classBEMRoot}__content__text`}>
							<div className={`${this.props.classBEMRoot}__content__title`}>{this.props.title}</div>
							<div className={`${this.props.classBEMRoot}__content__desc`} dangerouslySetInnerHTML={{ __html: this.props.desc }} />
						</div>
						{this.props.children}
					</div>

				</div>
			</CSSTransition>
		);
	}
}
